import './form.scss';

class Formular {
    constructor (element) {
        this.$form = element;
        this.$inputs = this.$form.querySelectorAll('[data-form="input"]');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.$inputs.length > 0) {
            this.$inputs.forEach((input) => {
                const $parent = input.parentElement;

                if ($parent) {
                    input.addEventListener('focus', () => {
                        $parent.classList.add('is--active');
                    });

                    input.addEventListener('blur', () => {
                        $parent.classList.remove('is--active');
                    });
                }
            });
        }
    }
}

export { Formular };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $forms = $context.querySelectorAll('[data-form="root"]');

        if ($forms.length > 0) {
            $forms.forEach((form) => {
                const $form = new Formular(form);
                $form.initialize();
            });
        }
    }
});
